import React, { Component } from 'react';

import { Modal } from 'antd';

import { inject, observer } from 'mobx-react';

import ContactusIcon from '../../../../common/icons/ContactusIcon';
import WhatsappIcon from '../../../../common/icons/WhatsappIcon';

import PromptModal from '../../../../common/components/PromptModal';

import { api } from '../../../../services';

import './Actions.css';

@inject('translationsStore', 'commonStore')
@observer
export default class CommunicationCard extends Component {
  constructor(props) {
    super(props);
    this.PromptModal = React.createRef();
  }

  componentDidMount = () => {
    this.PromptModalInstance = this.PromptModal.current;
  };

  modalSuccess = (title = this.props.translationsStore.translate('carView.CommunicationCard.modal.success')) =>
    Modal.success({
      title
    });

  sendSMS = content => {
    api('send sms', content, this.props.carId, this.props.lead.id).then(response => {
      if (response.success === true) {
        this.modalSuccess();
        this.props.onChange();
      }
    });
  };

  sendEmail = content => {
    api('send email', content, this.props.carId, this.props.lead.id).then(() => {
      this.modalSuccess();
      this.props.onChange();
    });
  };

  clientReject = reason => {
    api('client discard', reason, this.props.lead.id).then(response => {
      if (response.success === true) {
        this.modalSuccess();
        this.props.onChange();
      }
    });
  };

  getModalOptions = media => {
    const { client, dealer, lead, translationsStore } = this.props;
    const title = translationsStore.translate(`carView.CommunicationCard.modal.title.${media}`);
    let textareaValue = '';
    if (this.props.lead && this.props.lead.status === 'notified') {
      textareaValue = lead.status === 'notified' ? translationsStore.translate(`carView.CommunicationCard.modal.defaultValue.${media}`) : null;
      textareaValue = textareaValue
        .replace('##customer##', client.fullName)
        .replace('##dealerName##', dealer.name)
        .replace('##dealerPhone##', dealer.mobile);
    }
    return { title, textareaValue };
  };

  openSMSModal = () => {
    const { title, textareaValue } = this.getModalOptions('sms');
    this.PromptModalInstance.open({ title, onOk: this.sendSMS, textarea: true, textareaValue });
  };

  openEmailModal = () => {
    const { title, textareaValue } = this.getModalOptions('email');
    this.PromptModalInstance.open({ title, onOk: this.sendEmail, textarea: true, textareaValue });
  };

  openConfirmActionModal = () => {
    const title = this.props.translationsStore.translate('carView.CommunicationCard.modal.title.action');
    const content = this.props.translationsStore.translate('carView.CommunicationCard.modal.content.action');
    this.PromptModalInstance.open({ title, onOk: this.clientRequestAction, textarea: false, content });
  };

  render() {
    const { style } = this.props;
    return (
      <div className="Actions" style={style}>
        <div className="inOut">
          <div className="in">
            <div className="label">{this.props.translationsStore.translate('contactCustomer')}</div>
            <div className="sms" onClick={this.openSMSModal}>
              <div>SMS</div>
            </div>
            <div className="email" onClick={this.openEmailModal}>
              <div>
                <ContactusIcon type="email" />
              </div>
            </div>
            <div className="Whatsapp">
              <div>
                <WhatsappIcon />
              </div>
            </div>
            <div className="Call">
              <div>
                <ContactusIcon type="call" />
              </div>
            </div>
          </div>
        </div>
        <PromptModal ref={this.PromptModal} />
      </div>
    );
  }
}
